import store from '../../store'

export default (to, from, next) => {
	if (store.getters.getLoggedInState) {
		next({ name: 'dashboard' })
	} else {
		next()
	}
}



// WEBPACK FOOTER //
// ./src/router/middleware/guest.js